import { useEffect } from 'react'
import { useFlag } from '@calendly/feature-check-react'

import {
  handleConsentUpdateMessage,
  subscribeConsentUpdate,
} from 'services/consent/consent_update_handoff'
import { consentModule } from 'services/consent/consent_module'

/**
 * Registers window message listener for updating embed consent. Messages are only applied
 * when embed_domain on the URL matches the postMessage origin (see consent_update_handoff).
 *
 * When the `sa_consent_aware_embed` flag is on, also forwards normalized consent updates from
 * the transport into the centralized consent module so consumers (analytics, marketing, etc.)
 * can read a single resolved ConsentState. When the flag is off, the transport still
 * registers the listener but the module is not fed — keeping the new module dark for the
 * initial rollout per SA-3901's "introduce behind a feature flag and wire minimally" plan.
 */
export const ConsentUpdateMessageListener = () => {
  const consentModuleEnabled = useFlag('sa_consent_aware_embed', false)

  useEffect(() => {
    window.addEventListener('message', handleConsentUpdateMessage)
    return () => window.removeEventListener('message', handleConsentUpdateMessage)
  }, [])

  useEffect(() => {
    if (!consentModuleEnabled) return undefined
    return subscribeConsentUpdate((payload) => {
      consentModule.updateFromHost(payload)
    })
  }, [consentModuleEnabled])

  return null
}
